import { style } from "@vanilla-extract/css";
import { newsContainer } from "../../../styles/containers.css";

export const newsListStyles = style({
  containerName: newsContainer,
  containerType: "inline-size",
});
